<div class="row">
  <div class="col-sm-6">
    <app-country-select [country]="country" (countryChange)="country = $event">
    </app-country-select>
  </div>
  <div class="col-sm-6">
    @if (country) {
      <p-autocomplete
        [(ngModel)]="searchQuery"
        [suggestions]="locationList"
        (completeMethod)="search($event)"
        (onSelect)="onLocationChange($event)"
        [placeholder]="getPlaceholder()"
        minQueryLength="3"
        [appendTo]="appendTo()"
        [showEmptyMessage]="true"
        optionLabel="cityName"
      >
        <ng-template #empty>
          <app-autocomplete-empty-message
            [loading]="loading()"
            text="Location not found"
          ></app-autocomplete-empty-message>
        </ng-template>
      </p-autocomplete>
    }
  </div>
</div>
